import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ButtonOutlined = styled(({ ...props }: any) => (
    <Button variant="contained" {...props} />
))(({ theme, label }) => ({
    minWidth: 0,
    minHeight: 0,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    background: 'white',
    color: `${theme.palette.primary[400]}`,
    border: `1px solid ${theme.palette.primary[400]}`,
    ':hover': {
        background: `${theme.palette.primary[400]}`,
        color: 'white',
        borderColor: `${theme.palette.primary[400]}`,
    },
}));

export default ButtonOutlined;
